module.exports = __webpack_public_path__ + "img/ico1.8b914a7b.png";